import React, { Fragment } from 'react'
import { Col, Container, Row } from 'reactstrap'
import MasonryDescription from './MasonryDescription'
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs'
import { MasonryDescriptionTitle, GalleryTitle } from '../../../../Utils/Constants'

export default function MasonryDescriptionContainer() {
    return (
        <Fragment>
            <Breadcrumbs pageTitle={MasonryDescriptionTitle} parent={GalleryTitle} title={MasonryDescriptionTitle} />
            <Container fluid>
                <Row>
                    <Col sm={12}>
                        <MasonryDescription />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
